module.exports = __webpack_public_path__ + "img/cooperationImg16.98e54521.png";